/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Injectable } from "@angular/core";
import { Url_WebSocket_BuildUrl } from "app/rest-constants";
import { Subject } from "rxjs";
import { AuthenticationService } from "./authentication.service";
import { WebSocketService } from "./websocket.service";

@Injectable()
export class MonitorZoneWebSocketService {

    constructor(
      private mAuthenticationService: AuthenticationService,
      private mWebSocketService: WebSocketService
    ) { }

    public create(zoneInstanceId: number): Subject<MessageEvent> {
      //Get information required to build URL...
      const authToken = this.mAuthenticationService.getToken();
  
      //Build the URL...
      const url = Url_WebSocket_BuildUrl(authToken, `monitor-zone/${zoneInstanceId}`);
  
      //Create the Web Socket connection / subscription and return it...
      return this.mWebSocketService.connect(url);
    }
}
